export * from './config';
export * from './firebaseConfig.web';
